import service from '../../../../services';
import vSelect from 'vue-select';
import FormattedProductValue from '../FormattedProductValue/FormattedProductValue.vue';
import throttle from 'lodash/throttle';

export default {
  name: 'SingleProductsList',
  components: {
    'v-select': vSelect,
    FormattedProductValue,
  },
  props: {
    products: { type: Array },
    disabled: Boolean,
  },
  data() {
    return {
      rcfMaxCoverage: 0,
      normalizedProducts: [],
      previousValues: {},
      isDragging: false,
      currentItem: null,
    };
  },
  mounted() {
    this.normalizeBigValues(this.products);
    this.validateRcfTotalValue();
    document.addEventListener('mouseup', this.handleSliderEventUp);
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.handleSliderEventUp);
  },
  watch: {
    products(newProducts) {
      this.normalizeBigValues(newProducts);
    },
  },
  async created() {
    this.setRcfMaxCoverage();
    this.validateRcfTotalValue();
  },
  methods: {
    handleClick(item) {
      this.isDragging = true;
      this.currentItem = item;

      const previousQuantity = this.previousValues[item.productName];

      if (previousQuantity !== item.quantity) {
        this.updateValue(this.currentItem);
        this.$set(this.previousValues, item.productName, item.quantity);
      }

      this.isDragging = false;
      this.currentItem = null;
    },
    handleSliderEventDown(item) {
      this.isDragging = true;
      this.currentItem = item;
    },
    handleSliderEventUp() {
      if (!this.isDragging || !this.currentItem) return;

      const { productName, quantity } = this.currentItem;
      const previousQuantity = this.previousValues[productName];

      if (previousQuantity !== quantity) {
        this.updateValue(this.currentItem);
        this.$set(this.previousValues, productName, quantity);
      }

      this.isDragging = false;
      this.currentItem = null;
    },
    normalizeBigValues(products) {
      if (!products) return;
      this.normalizedProducts = this.products.map((product) => {
        if (product.unity === 'mil') {
          this.$set(
            this.previousValues,
            product.productName,
            product.quantity / 1000,
          );
          return {
            ...product,
            min: product.min / 1000,
            max: product.max / 1000,
            step: product.step / 1000,
            quantity: product.quantity / 1000,
          };
        }

        if (product.hasOwnProperty('options') && product.options.length === 1) {
          product.options[0].quantity = 1;
        }

        this.$set(this.previousValues, product.productName, product.quantity);
        return product;
      });
    },
    checkStep(step, min, max) {
      const total = max - min;
      const isDivisible = total % step === 0;

      if (isDivisible) return step;
      return total / 10;
    },
    updateValue(itemChanged) {
      if (itemChanged.max < itemChanged.quantity)
        itemChanged.quantity = itemChanged.max;
      if (itemChanged.grouping === 'rcf') this.validateRcfTotalValue();
      const denormalizedBigValues =
        itemChanged.unity === 'mil'
          ? {
              ...itemChanged,
              min: itemChanged.min * 1000,
              max: itemChanged.max * 1000,
              step: itemChanged.step * 1000,
              quantity: itemChanged.quantity * 1000,
            }
          : itemChanged;
      this.$emit('update:products', denormalizedBigValues);
    },
    calculateTotalGrouping(grouping) {
      let total = 0;
      this.normalizedProducts
        .filter((product) => product.grouping === grouping)
        .forEach((product) => {
          total +=
            product.unity === 'mil'
              ? product.quantity * 1000
              : product.quantity;
        });
      return total;
    },
    validateRcfTotalValue() {
      const grouping = 'rcf';
      this.normalizedProducts
        .filter((product) => product.grouping === grouping)
        .forEach((product) => {
          const groupingTotal = this.calculateTotalGrouping(grouping);
          if (groupingTotal <= this.rcfMaxCoverage) {
            this.$validator.errors.remove(product.productName);
            this.$emit('update:isValidRcfValue', true);
            return;
          }
          this.$validator.errors.add({
            field: product.productName,
            msg: `A soma dos itens do grupo não pode exceder R$ ${this.rcfMaxCoverage}`,
          });
          this.$emit('update:isValidRcfValue', false);
        });
    },
    setRcfMaxCoverage() {
      service
        .getAll('g', {}, 'empresas/list/idEmpresa/idEmpresa=null')
        .then((res) => {
          this.rcfMaxCoverage = res.data[0].coverageMaxRcf;
        });
    },
  },
};
